import { useMemo, useState, type FormEvent } from 'react'
import { ApiError } from '../../api/client'
import { useAction } from '../../api/queries'
import type { Equipment } from '../../api/types'
import { Field, Modal } from '../../components/ui'
import { buildPatch, toFormState, validateForm, type FormState } from './equipmentForm'
import { EquipmentSpecFields, FORM_ERROR_KEYS } from './EquipmentSpecFields'

export function EditEquipmentModal({ equipment, onClose }: { equipment: Equipment; onClose: () => void }) {
  const [state, setState] = useState<FormState>(() => toFormState(equipment))
  const [local, setLocal] = useState<Record<string, string>>({})
  const [error, setError] = useState<ApiError | null>(null)
  const save = useAction<Record<string, unknown>, Equipment>('patch', `/api/equipment/${equipment.id}/`, ['/api/equipment', '/api/assets/tree/'])
  const dirty = useMemo(() => Object.keys(buildPatch(equipment, state)).length > 0, [equipment, state])

  async function submit(e: FormEvent) {
    e.preventDefault(); setError(null)
    const problems = validateForm(state)
    setLocal(problems)
    if (Object.keys(problems).length) return
    try {
      await save.mutateAsync(buildPatch(equipment, state))
      onClose()
    } catch (err) { setError(err as ApiError) }
  }

  const fe = { ...(error?.fieldErrors ?? {}), ...local }
  const stray = Object.entries(error?.fieldErrors ?? {}).filter(([k]) => !FORM_ERROR_KEYS.has(k)).map(([, m]) => m)
  const generic = error && (!Object.keys(error.fieldErrors).length || stray.length) ? (stray.length ? stray.join(' ') : error.message) : null

  return (
    <Modal title="Editar equipo" onClose={onClose} wide>
      <form className="form-stack" onSubmit={submit} noValidate>
        <p className="muted">Código <span className="mono">{equipment.code}</span> (no se puede cambiar). Solo se envían los datos que cambies.</p>
        <Field label="Nombre" htmlFor="edit-name" error={fe.name}><input id="edit-name" value={state.values.name} onChange={(e) => setState((s) => ({ ...s, values: { ...s.values, name: e.target.value } }))} /></Field>
        <EquipmentSpecFields state={state} setState={setState} errors={fe} idPrefix="edit" defaultOpen />
        {generic ? <p role="alert" className="form-error">{generic}</p> : null}
        <div className="row">
          <button type="button" className="btn btn--ghost" onClick={onClose}>Cancelar</button>
          <button className="btn btn--primary" disabled={!dirty || save.isPending}>Guardar cambios</button>
        </div>
      </form>
    </Modal>
  )
}
